import { createContext, useContext, type ReactNode } from "react";
import { systemTz } from "./time";

/**
 * 当前租户（A0）的时区。全站时间的展示与编辑都取它，**不取浏览器时区**。
 *
 * 放 context 而不是每个组件各自传：时间字段会散在活动、竞拍、卡牌等多个页面，
 * 逐层透传迟早漏一个——漏掉的那个就会按浏览器时区渲染，且看起来完全正常。
 */
const TzContext = createContext<string>(systemTz());

export const TzProvider = ({ tz, children }: { tz: string; children: ReactNode }) => (
  <TzContext.Provider value={tz}>{children}</TzContext.Provider>
);

export const useTz = () => useContext(TzContext);

/**
 * A0 → IANA 时区。真实映射由后端 /admin/api 下发，这里先给已知的几个。
 *
 * **没登记的租户按运营本机时区显示**，不再回落 UTC：UTC 对谁都不是自己的时间，
 * 一个只在 test 用的租户会让所有时间看起来差 8 小时，而且看不出是「没配」还是「真 UTC」。
 * 登记过的仍按登记值 —— 跨区协作时同一个到期时刻必须在所有人屏幕上是同一个日期。
 */
export const TZ_BY_A0: Record<string, string> = {
  "11012184": "Asia/Tokyo",
  "11012183": "Asia/Shanghai",
  "11012182": "Asia/Taipei",
  "11012181": "Asia/Tokyo",
  "11012180": "Asia/Shanghai",
  "11012179": "UTC",
  "11012178": "Asia/Singapore",
  "11012177": "America/Los_Angeles",
};

export const tzOfAgent = (id: string | null) => (id == null ? systemTz() : (TZ_BY_A0[id] ?? systemTz()));
